// extracted by mini-css-extract-plugin
module.exports = {"MainPageCountersWrapper":"MainPageCounters_MainPageCountersWrapper__1Yq4s","CounterText":"MainPageCounters_CounterText__3w36W","Numbers":"MainPageCounters_Numbers__2KqOM"};